import { render, staticRenderFns } from "./Assessment.vue?vue&type=template&id=681a3b7b&scoped=true&"
import script from "./Assessment.vue?vue&type=script&lang=js&"
export * from "./Assessment.vue?vue&type=script&lang=js&"
import style0 from "./Assessment.vue?vue&type=style&index=0&id=681a3b7b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681a3b7b",
  null
  
)

export default component.exports